// extracted by mini-css-extract-plugin
export var large = "cta-module--large--4e29c";
export var link = "cta-module--link--f811c";
export var medium = "cta-module--medium--c0e12";
export var primary = "cta-module--primary--a7620";
export var secondary = "cta-module--secondary--4108a";
export var small = "cta-module--small--192a0";
export var wrapper = "cta-module--wrapper--2ecb1";